module.exports = __webpack_public_path__ + "img/blank-img.fea90313.jpg";